import { api } from './api';
import { createTreatyHooks } from './treaty-hooks';

export const apiHook = createTreatyHooks(() => api.api.api.v1);
